export default __webpack_public_path__ + "static/media/smartsuite-logo.5686d35a.svg";